module.exports = __webpack_public_path__ + "static/media/29470035-NrUzwSgs.dbf9e10e.JPG";